import { createBrowserRouter } from 'react-router-dom';
import protectedRoute from './protected.routes';
import publicRoute from './public.routes';


const protectedRouter = createBrowserRouter([...protectedRoute])
const publicRouter = createBrowserRouter([...publicRoute])


export default {
  protectedRouter,
  publicRouter,
};
